import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import { StoreProvider, store } from '@/stores';
import '@/i18n';
import '@/styles/index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
